<template>
    <layout title="Logs" icon="folder_shared" disable_scroll>

      <v-row justify="center">
        <v-col cols="5">
          <LogV2 :query_uuid="log_props.query_uuid" :query_uuid_keys="log_props.query_uuid_keys"></LogV2>
        </v-col>
      </v-row>
    </layout>
</template>

<script>
    import 'firebase/app';
    export default {
        beforeRouteEnter(to, from, next){
          next(vm => {
            if(to.query && to.query.log_props){
              console.log(to.query)
              vm.log_props = JSON.parse(to.query.log_props);
            }
          })
        },
        name: "index",
        data: () => ({
          log_props: {
            query_uuid: null,
            query_uuid_keys: []
          }
        }),
        components: {
            LogV2: () => import('@/components/logs/V2/LogList')
        },
        activated(){
          this.$refs.log_reader.getAndListenForLogs();
        },
        beforeRouteLeave(to, from , next){
            if(this.$refs.log_reader.readLogs !== null){
                this.$refs.log_reader.readLogs();
            }
            next();
        }
    }
</script>

